import React__default, { useState } from 'react';
import { exists } from '../../../typedash/dist/index.js';
import MaterialTooltip from '../../../../node_modules/@mui/material/Tooltip/Tooltip.js';

/**
 *
 * @param describeChild leaves tooltip open so you can mouse over it. i.e. if you want to copy the text
 * @param open
 * NOTE: describeChild and open can not both be present. For describeChild to work, mui needs open state control
 */
const Tooltip = ({ describeChild, placement, title, open, children }) => {
    const [tooltipState, setTooltipState] = useState(false);
    const isControlled = open ?? false;
    return (React__default.createElement(MaterialTooltip, { describeChild: describeChild, open: isControlled ? open : tooltipState, title: title, placement: placement, ...(exists(isControlled) && {
            onOpen: () => setTooltipState(true),
            onClose: () => setTooltipState(false),
        }) }, children));
};

export { Tooltip };
